import { Center, Stack, ThemeIcon } from "@mantine/core";
import { HiExclamationCircle } from "react-icons/hi2";
import { CustomText } from "../CustomText/CustomText";
import CustomButton from "../CustomButton/CustomButton";

export default function FetchFeedback({
  message = "Oops! Failed to load your data.",
  onRetry,
  fullHeight = true,
  compact = false,
}) {
  return (
    <Center mih={fullHeight ? "80vh" : undefined} p={compact ? "xs" : "md"}>
      <Stack align="center" gap={compact ? 4 : "sm"}>
        <ThemeIcon
          size={compact ? 30 : { base: 50, sm: 60, md: 70 }}
          radius="xl"
          variant="light"
          color="red"
        >
          <HiExclamationCircle size={compact ? 16 : 32} />
        </ThemeIcon>
        <CustomText
          ta="center"
          size={compact ? "xs" : { base: "sm", sm: "md", md: "lg" }}
          c="dimmed"
          fw={500}
        >
          {message}
        </CustomText>

        {onRetry && (
          <CustomButton
            onClick={onRetry}
            size={compact ? "xs" : "sm"}
          >
            Try Again
          </CustomButton>
        )}
      </Stack>
    </Center>
  );
}
